import React, { useState, useEffect } from "react";
import Topbar from "./topBar";
import Sidebar from "./sideBar";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "react-tagsinput/react-tagsinput.css";
import { Link } from "react-router-dom";
import { getAllOrders } from "../actions/adminAction";
import { FiEye } from "react-icons/fi";
import { getStatusString } from "../constants/enumConstants";
import { FaImage } from "react-icons/fa";
import ImageModal from "../images/imageModal";
import {
  VIEW_DET,
  VIEW_IMG,
} from "../constants/url";
import { Tooltip } from "react-tooltip";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Button,
  Dialog
} from "@mui/material";
import { ERR_ALERT_TITLE, ERR_GETTING } from "../constants/alertMessage";



const Orders = () => {
  const [values, setValues] = useState({
    error: "",
    orders: [],
    removed: false,
  });
  
  const [images, setImages] = useState([]);
  const [open, setOpen] = useState(false);  
  const [open1, setOpen1] = useState(false);  
  const [details, setDetails] = useState({});

  const { orders } = values;
  useEffect(() => {
    loadUserType();
  }, []);
  const handleClose = () => {
    setOpen(false);
  };
  const handleClose1 = () => {
    setOpen1(false);
  };
  const loadUserType = () => {
    getAllOrders().then((data) => {

      if (data.error) {
        Swal.fire({
          icon: "error",
          title: `${ERR_ALERT_TITLE}`,
          text: `${ERR_GETTING}`,
          confirmButtonText: "OK",
        });
      } else {

        setValues({ ...values, orders: data.orders });
      }
    })
    .catch((err)=>{
  
      Swal.fire({
        icon: "error",
        title: `${ERR_ALERT_TITLE}`,
        text: `${ERR_GETTING}`,
        confirmButtonText: "OK",
      });
    })
  };
  const edit = (cell, row, extraData, index) => {
   console.log(row,"row");
    const hasImageData = [row.image1, row.image2, row.image3, row.image4].some(
      (image) => image !== undefined && image !== null && image !== ""
    );
    const handleImageClick = () => {

      const imagesData = [row.image1, row.image2, row.image3, row.image4];

      const filteredImagesData = imagesData.filter(
        (image) => image !== undefined && image !== null && image !== ""
      );

      setImages(filteredImagesData);
      setOpen(true);
    };
   
    const handlePOP = (e) => {
      
      setDetails(row);
      setOpen1(true);
    };

    return (
      <span>
            {hasImageData && (
          <i
            className="ml-1"
            data-tooltip-id="5"
            data-tooltip-content={`${VIEW_IMG}`}
          >
            {" "}
            <FaImage onClick={handleImageClick} color="green" size="17" />
          </i>
        )}
        <Tooltip id="5" />
        <i
          className="ml-1"
          data-tooltip-id="1"
          data-tooltip-content={`${VIEW_DET}`}
        >
          {" "}
          <FiEye onClick={handlePOP} color="#9368f3" size="20" />
          <Tooltip id="1" />
        </i>

        <div
          className="modal fade bs-example-modal-center"
          id={"details" + row.id}
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Product Details
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <table className="col-12">
                  <tr>
                    <td className="text-left"> Seller Name</td>
                    <td
                      className="text-dark text-right font-weight-normal"
                      id="des"
                    >
                      {row.sellerName}
                    </td>
                  </tr>

                  <tr>
                    <td className="text-left"> Seller Mobile</td>
                    <td className="text-dark text-right font-weight-normal">
                      {row.sellerMobile}
                    </td>
                  </tr>

                  <tr>
                    <td className="text-left"> Product Title</td>
                    <td className="text-dark text-right font-weight-normal">
                      {row.title}
                    </td>
                  </tr>

                  <tr>
                    <td className="text-left"> Description</td>
                    <td
                      className="text-dark text-right font-weight-normal"
                      id="des"
                    >
                      {row.description}
                    </td>
                  </tr>

                  <tr>
                    <td className="text-left"> Quantity</td>
                    <td
                      className="text-dark text-right font-weight-normal"
                      id="des"
                    >
                      {row.qty}
                    </td>
                  </tr>

                  <tr>
                    <td className="text-left"> Unit</td>
                    <td className="text-dark text-right font-weight-normal">
                      {row.unit}
                    </td>
                  </tr>

                  <tr>
                    <td className="text-left"> Avialable Date</td>
                    <td className="text-dark text-right font-weight-normal">
                      {row.availableDate}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left"> Expiry Date</td>
                    <td className="text-dark text-right font-weight-normal">
                      {row.expDate}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left"> Features</td>
                    <td>
                      <div className="row justify-content-end">
                        {row.auction_status === "1" && (
                          <img
                            className="img-responsive "
                            src={"/assets/icons/bid_icon.png"}
                            alt="user"
                            style={{ width: "40px", height: "40px" }}
                          />
                        )}
                        {row.safe_status === "1" &&
                          row.organic_status === "1" && (
                            <img
                              className="img-responsive ml-1"
                              src={"/assets/icons/organi_1.jpg"}
                              alt="user"
                              style={{ width: "40px", height: "40px" }}
                            />
                          )}

                        {row.safe_status === "1" &&
                          row.organic_status === "0" && (
                            <img
                              className="img-responsive ml-1"
                              src={"/assets/icons/safe_icon.jpg"}
                              alt="user"
                              style={{ width: "40px", height: "40px" }}
                            />
                          )}

                        {row.transpot_status === "1" && (
                          <img
                            className="img-responsive ml-1"
                            src={"/assets/icons/trucks.png"}
                            alt="user"
                            style={{ width: "40px", height: "40px" }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  };


  return (
    <div id="wrapper">
      <Topbar backgroundColor="#769A0F" />
      <Sidebar />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        {" "}
                        <Link to="/dashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Orders</li>
                    </ol>
                  </div>
                  <h4 className="page-title">Orders</h4>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card-box">
                  <div
                    style={{
                      width: "98%",
                    }}
                  >
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>S.No</TableCell>
                            <TableCell>Buyer Name</TableCell>
                            <TableCell>Buyer Mobile</TableCell>
                            <TableCell>Seller Name</TableCell>
                            <TableCell>Seller Mobile</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Title</TableCell>
                            <TableCell>Price</TableCell>
                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {orders.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{row.buyerName}</TableCell>
                              <TableCell>{row.buyerMobile}</TableCell>
                              <TableCell>{row.sellerName}</TableCell>
                              <TableCell>{row.sellerMobile}</TableCell>
                              <TableCell> <span className="btn-sm btn-success">
                                  {getStatusString(row.status)}
                                </span></TableCell>
                              <TableCell>{row.title}</TableCell>
                              <TableCell>{row.price}</TableCell>
                            
                              <TableCell>
                                {edit(null, row, null, index)}
                              </TableCell>
                            </TableRow>
                          ))}
                               <ImageModal handleClose={handleClose}
                            open={open}
                            imageSrc={images}>

                          </ImageModal>
                          <Dialog
                            open={open1}
                            onClose={handleClose1}
                            aria-labelledby="details-modal-title"
                            aria-describedby="details-modal-description"
                            style={{
                              maxHeight: "80vh",
                              overflowY: "auto",
                              marginTop: "100px",
                            }}
                            fullWidth
                            disableEnforceFocus
                            maxWidth="lg"
                          >
                            <Grid
                              container
                              justifyContent="center"
                              alignItems="center"
                              className="modal-content"
                            >
                              <Grid item xs={12} className="modal-header">
                                <h5 id="details-modal-title">Details</h5>
                                <Button onClick={handleClose1} color="inherit">
                                  {" "}
                                  <span
                                    style={{ fontSize: "20px" }}
                                    aria-hidden="true"
                                  >
                                    &#128473;
                                  </span>
                                </Button>
                              </Grid>
                              <Grid item xs={12} className="modal-body">
                                <Table className="col-12">
                                <TableRow>
                                    <TableCell className="text-left">
                                      Title
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.title}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Seller Name
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.sellerName}
                                    </TableCell>
                                  </TableRow>
                                 
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Seller Mobile
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.sellerMobile}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Buyer Name
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.sellerName}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      
                                      Buyer Moblie
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.buyerMobile}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Description
                                    </TableCell>
                                    <TableCell
                                      className="text-dark text-right font-weight-normal"
                                    >
                                      {details.description}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                     Expiry Date
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.expDate}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Price
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.price}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Quantity
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.qty}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Unit
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.unit}
                                    </TableCell>
                                  </TableRow>


                                  <TableRow>
                                    <TableCell className="text-left">
                                      Location
                                    </TableCell>
                                    <TableCell
                                      className="text-dark text-right font-weight-normal"
                                    >
                                      {details.location}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Status
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.status}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Delivery Available
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.availableDate}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Free Delivery
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.transpot_status}
                                    </TableCell>
                                  </TableRow>
                                  
                                </Table>
                              </Grid>
                              <Grid item xs={12} className="modal-footer">
                                <Button
                                  onClick={handleClose1}
                                  variant="outlined"
                                  color="error"
                                >
                                  Close
                                </Button>
                              </Grid>
                            </Grid>
                          </Dialog>
                        </TableBody>
                      </Table>
                    </TableContainer>

              
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orders;
